import React from "react"

const NotFound = () => {
    return (
        <h1 className="notfound">The page you are looking for doesn't exist</h1>
    )
}

export default NotFound